// ==================== SUB-ACCOUNT CONFIRM DIALOGS ====================

import { ConfirmDialog } from '../ui';
import type { SubAccount } from '../../services/sub-accounts.service';

interface SubAccountConfirmDialogsProps {
  deleteConfirm: SubAccount | null;
  onCloseDelete: () => void;
  onConfirmDelete: () => void;
  deleting: boolean;
  toggleConfirm: SubAccount | null;
  onCloseToggle: () => void;
  onConfirmToggle: () => void;
  toggling: boolean;
}

export const SubAccountConfirmDialogs = ({
  deleteConfirm,
  onCloseDelete,
  onConfirmDelete,
  deleting,
  toggleConfirm,
  onCloseToggle,
  onConfirmToggle,
  toggling,
}: SubAccountConfirmDialogsProps) => {
  const toggleName = toggleConfirm ? `${toggleConfirm.firstName} ${toggleConfirm.lastName}` : '';

  return (
    <>
      {/* Delete Confirmation */}
      <ConfirmDialog
        isOpen={!!deleteConfirm}
        onClose={onCloseDelete}
        onConfirm={onConfirmDelete}
        title="Delete Sub-account"
        description={`Are you sure you want to delete the "${deleteConfirm?.firstName} ${deleteConfirm?.lastName}" sub-account? They will no longer be able to sign in. Their assigned contacts stay with this account and become unassigned. This action cannot be undone.`}
        confirmText="Delete Sub-account"
        variant="danger"
        isLoading={deleting}
      />

      {/* Status Toggle Confirmation */}
      <ConfirmDialog
        isOpen={!!toggleConfirm}
        onClose={onCloseToggle}
        onConfirm={onConfirmToggle}
        title={toggleConfirm?.isActive ? 'Deactivate Sub-account' : 'Activate Sub-account'}
        description={
          toggleConfirm?.isActive
            ? `Are you sure you want to deactivate the "${toggleName}" sub-account? They will be signed out and won't be able to sign in until activated again.`
            : `Are you sure you want to activate the "${toggleName}" sub-account? They will be able to sign in again.`
        }
        confirmText={toggleConfirm?.isActive ? 'Deactivate' : 'Activate'}
        variant={toggleConfirm?.isActive ? 'warning' : 'success'}
        isLoading={toggling}
      />
    </>
  );
};

export default SubAccountConfirmDialogs;
